import axios from 'axios';

const API_URL = 'https://api.laur.world/api';

const login = async (username, password) => {
  try {
    const response = await axios.post(`${API_URL}/login`, {
      username,
      password,
    });
    
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response.data;
  } catch (error) {
    console.error('Login error:', error.response?.data?.message || error.message);
    throw error.response?.data?.message || 'An error occurred during login';
  }
};

const register = async (username, password) => {
  try {
    const response = await axios.post(`${API_URL}/register`, {
      username,
      password,
    });
    return response.data;
  } catch (error) {
    console.error('Registration error:', error.response?.data?.message || error.message);
    throw error.response?.data?.message || 'An error occurred during registration';
  }
};

const changePassword = async (oldPassword, newPassword) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.post(
      `${API_URL}/change-password`,
      { oldPassword, newPassword },
      {
        headers: { Authorization: `Bearer ${token}` }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Change password error:', error.response?.data?.message || error.message);
    throw error.response?.data?.message || 'An error occurred while changing password';
  }
};

const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
};

const isAuthenticated = () => {
  return !!localStorage.getItem('token');
};

const getUser = () => {
  const user = localStorage.getItem('user');
  return user ? JSON.parse(user) : null;
};

export { login, register, logout, isAuthenticated, getUser, changePassword };
